import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-aef45858")

_pushScopeId("data-v-aef45858")
const _hoisted_1 = { class: "multi-position-panel" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("水平均匀分布")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("垂直均匀分布")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("组合")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("取消组合")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_IconAlignLeft = _resolveComponent("IconAlignLeft")
  const _component_Button = _resolveComponent("Button")
  const _component_Tooltip = _resolveComponent("Tooltip")
  const _component_IconAlignVertically = _resolveComponent("IconAlignVertically")
  const _component_IconAlignRight = _resolveComponent("IconAlignRight")
  const _component_ButtonGroup = _resolveComponent("ButtonGroup")
  const _component_IconAlignTop = _resolveComponent("IconAlignTop")
  const _component_IconAlignHorizontally = _resolveComponent("IconAlignHorizontally")
  const _component_IconAlignBottom = _resolveComponent("IconAlignBottom")
  const _component_Divider = _resolveComponent("Divider")
  const _component_IconGroup = _resolveComponent("IconGroup")
  const _component_IconUngroup = _resolveComponent("IconUngroup")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_ButtonGroup, { class: "row" }, {
      default: _withId(() => [
        _createVNode(_component_Tooltip, {
          mouseLeaveDelay: 0,
          mouseEnterDelay: 0.5,
          title: "左对齐"
        }, {
          default: _withId(() => [
            _createVNode(_component_Button, {
              style: {"flex":"1"},
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.alignElement('left')))
            }, {
              default: _withId(() => [
                _createVNode(_component_IconAlignLeft)
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["mouseEnterDelay"]),
        _createVNode(_component_Tooltip, {
          mouseLeaveDelay: 0,
          mouseEnterDelay: 0.5,
          title: "水平居中"
        }, {
          default: _withId(() => [
            _createVNode(_component_Button, {
              style: {"flex":"1"},
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.alignElement('horizontal')))
            }, {
              default: _withId(() => [
                _createVNode(_component_IconAlignVertically)
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["mouseEnterDelay"]),
        _createVNode(_component_Tooltip, {
          mouseLeaveDelay: 0,
          mouseEnterDelay: 0.5,
          title: "右对齐"
        }, {
          default: _withId(() => [
            _createVNode(_component_Button, {
              style: {"flex":"1"},
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.alignElement('right')))
            }, {
              default: _withId(() => [
                _createVNode(_component_IconAlignRight)
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["mouseEnterDelay"])
      ]),
      _: 1
    }),
    _createVNode(_component_ButtonGroup, { class: "row" }, {
      default: _withId(() => [
        _createVNode(_component_Tooltip, {
          mouseLeaveDelay: 0,
          mouseEnterDelay: 0.5,
          title: "上对齐"
        }, {
          default: _withId(() => [
            _createVNode(_component_Button, {
              style: {"flex":"1"},
              onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.alignElement('top')))
            }, {
              default: _withId(() => [
                _createVNode(_component_IconAlignTop)
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["mouseEnterDelay"]),
        _createVNode(_component_Tooltip, {
          mouseLeaveDelay: 0,
          mouseEnterDelay: 0.5,
          title: "垂直居中"
        }, {
          default: _withId(() => [
            _createVNode(_component_Button, {
              style: {"flex":"1"},
              onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.alignElement('vertical')))
            }, {
              default: _withId(() => [
                _createVNode(_component_IconAlignHorizontally)
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["mouseEnterDelay"]),
        _createVNode(_component_Tooltip, {
          mouseLeaveDelay: 0,
          mouseEnterDelay: 0.5,
          title: "下对齐"
        }, {
          default: _withId(() => [
            _createVNode(_component_Button, {
              style: {"flex":"1"},
              onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.alignElement('bottom')))
            }, {
              default: _withId(() => [
                _createVNode(_component_IconAlignBottom)
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["mouseEnterDelay"])
      ]),
      _: 1
    }),
    (_ctx.activeElementList.length > 2)
      ? (_openBlock(), _createBlock(_component_ButtonGroup, {
          key: 0,
          class: "row"
        }, {
          default: _withId(() => [
            _createVNode(_component_Button, {
              style: {"flex":"1"},
              onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.uniformHorizontalDisplay()))
            }, {
              default: _withId(() => [
                _hoisted_2
              ]),
              _: 1
            }),
            _createVNode(_component_Button, {
              style: {"flex":"1"},
              onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.uniformVerticalDisplay()))
            }, {
              default: _withId(() => [
                _hoisted_3
              ]),
              _: 1
            })
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    _createVNode(_component_Divider),
    _createVNode(_component_ButtonGroup, { class: "row" }, {
      default: _withId(() => [
        _createVNode(_component_Button, {
          disabled: !_ctx.canCombine,
          onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.combineElements())),
          style: {"flex":"1"}
        }, {
          default: _withId(() => [
            _createVNode(_component_IconGroup, { style: {"margin-right":"3px"} }),
            _hoisted_4
          ]),
          _: 1
        }, 8, ["disabled"]),
        _createVNode(_component_Button, {
          disabled: _ctx.canCombine,
          onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.uncombineElements())),
          style: {"flex":"1"}
        }, {
          default: _withId(() => [
            _createVNode(_component_IconUngroup, { style: {"margin-right":"3px"} }),
            _hoisted_5
          ]),
          _: 1
        }, 8, ["disabled"])
      ]),
      _: 1
    })
  ]))
})